__turbopack_context__.v({
  "helios-icon-feature-list": "RWNQua_helios-icon-feature-list",
  "helios-icon-feature-list--columns-3": "RWNQua_helios-icon-feature-list--columns-3",
  "helios-icon-feature-list--columns-4": "RWNQua_helios-icon-feature-list--columns-4",
  "helios-icon-feature-list__body": "RWNQua_helios-icon-feature-list__body",
  "helios-icon-feature-list__icon": "RWNQua_helios-icon-feature-list__icon",
  "helios-icon-feature-list__item": "RWNQua_helios-icon-feature-list__item",
  "helios-icon-feature-list__title": "RWNQua_helios-icon-feature-list__title",
});
